function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M233 230.677c41.421 0 75-32.483 75-72.554 0-40.07-33.579-72.554-75-72.554s-75 32.484-75 72.554c0 40.071 33.579 72.554 75 72.554z",
  fill: "#00645F"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.59,
  d: "M233.546 86.537c-13.243 0-25.698 3.306-36.546 9.093l69.226 81.841S309 176.049 309 159.449c0-40.275-33.775-72.912-75.454-72.912z",
  fill: "#00A872"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110 237.977c67.931 0 123-53.273 123-118.989C233 53.273 177.931 0 110 0S-13 53.273-13 118.988c0 65.716 55.069 118.989 123 118.989z",
  fill: "#008187"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.166 7.739C21.312 24.006-13 68.122-13 119.992c0 65.696 55.05 118.952 122.958 118.952 32.505 0 62.077-12.209 84.042-32.138C150.751 139.592 103.41 64.889 69.166 7.739z",
  fill: "url(#bush-corner_svg__paint0_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M208.469 49.678a120.081 120.081 0 00-29.105-28.395C151.074 81.548 115.584 162.333 84 235.54c32.026 6.387 66.565.331 95.33-19.526 55.154-38.126 68.229-112.59 29.139-166.336z",
  fill: "url(#bush-corner_svg__paint1_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84 250.992s14.601-38.304 65.5-38.304c51.854 0 65.569 38.304 65.569 38.304H84zm-138 .391s14.601-38.695 65.5-38.695c51.854 0 64.059 38.304 64.059 38.304L-54 251.383z",
  fill: "#00855D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-58 191.34l216-.326v59.978h-3.407V194.6L-58 195.578v-4.238z",
  fill: "#070634"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#070634",
  d: "M127 193.916h3v57.076h-3zm-25-.38h3v57.456h-3zm-25 0h3v57.456h-3zm-25 1.008h3v56.448h-3v-56.448zm-25-1.008h3v57.456h-3zm-25-1.008h3v58.464H2v-58.464z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "bush-corner_svg__paint0_linear",
  x1: 194.632,
  y1: 238.183,
  x2: 192.656,
  y2: 6.73,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#016879"
})), React.createElement("linearGradient", {
  id: "bush-corner_svg__paint1_linear",
  x1: 228.747,
  y1: 187.96,
  x2: 225.649,
  y2: -21.818,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 0.999,
  stopColor: "#008083"
})));

var SvgBushCorner = function SvgBushCorner(props) {
  return React.createElement("svg", _extends({
    width: 309,
    height: 252,
    viewBox: "0 0 309 252",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default "data:image/svg+xml;base64,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";
export { SvgBushCorner as ReactComponent };